import React from 'react';
import Img from 'react-cool-img';
import EmailUnread from 'spw-static/images/email-unread.svg';
import Close from 'spw-static/images/delete-input-icon.svg';
import { UnstyledReactLink } from 'spw-shared/globalComponents';
import {
  DialogBox,
  DialogCustom,
  GradientBackgroundContainer,
  LockoutText,
  CloseButton,
} from '../styles';

const RecoveryEmailSent = () => {
  return (
    <GradientBackgroundContainer>
      <DialogBox success>
        <DialogCustom>
          <Img
            src={EmailUnread}
            alt="recovery email sent"
            className="icon-image"
          />
          <UnstyledReactLink to="/login">
            <CloseButton>
              <Img src={Close} alt="close" />
            </CloseButton>
          </UnstyledReactLink>
          <div className="title">CHECK YOUR INBOX</div>
          <LockoutText>
            Space Plan Wizard has sent <br />
            you an email with a link to
            <br />
            change your password.
          </LockoutText>
        </DialogCustom>
      </DialogBox>
    </GradientBackgroundContainer>
  );
};

export default RecoveryEmailSent;
